import ModalCloseButton from '../generic/ModalCloseButton';

const NotAccessibleModal = ({ onClose, platformData }) => {
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-6"
      style={{
        background: 'rgba(16, 24, 40, 0.75)',
        backdropFilter: 'blur(8px)',
      }}
    >
      <div className="relative bg-[var(--q3-surface-default)] rounded-xl p-8 sm:p-10 w-[90%] max-w-md">
        <ModalCloseButton onClick={onClose} />

        <div className="flex flex-col gap-5 items-center text-center">
          <p className="text-[var(--q3-neutral-default)] text-2xl sm:text-3xl font-bold">
            This section is not accessible
          </p>
          <p className="text-[var(--q3-neutral-muted)] text-base sm:text-lg">
            You can access this section after the {platformData?.packName} result is released on{' '}
            <span className="font-bold">
              {new Date(platformData?.detailAccessDate).toLocaleDateString('en-IN', {
                day: 'numeric',
                month: 'long',
                year: 'numeric',
              })}
            </span>
            .
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotAccessibleModal;
